export type ConsentDecisionAction =
  | 'bannerAcceptAll'
  | 'bannerRejectAll'
  | 'preferencesAcceptAll'
  | 'preferencesRejectAll'
  | 'preferencesSave'

// Wire names. `signalHonored`: the signal wrote or overrode the cookie.
export const CONSENT_EVENT_NAMES = {
  bannerAcceptAll: 'button_tap.cookie_banner_accept_all',
  bannerRejectAll: 'button_tap.cookie_banner_reject_all',
  preferencesAcceptAll: 'button_tap.cookie_preferences_accept_all',
  preferencesRejectAll: 'button_tap.cookie_preferences_reject_all',
  preferencesSave: 'button_tap.cookie_preferences_save',
  signalHonored: 'gpc_signal.honored',
} as const satisfies Record<ConsentDecisionAction | 'signalHonored', string>
